import { useState, useRef } from "react";
import Testimonials from "../Testimonials";
import PlacedStudents from "../PlacedStudents";
import { useNavigate } from "react-router-dom";
import { Canvas, useFrame } from "@react-three/fiber";
import * as random from "maath/random/dist/maath-random.esm";
import { Points, PointMaterial } from "@react-three/drei";

function Stars(props) {
  const ref = useRef();
  const [sphere] = useState(() =>
    random.inSphere(new Float32Array(6000), { radius: 1.5 }),
  );

  useFrame((_, delta) => {
    ref.current.rotation.x -= delta / 10;
    ref.current.rotation.y -= delta / 15;
  });

  return (
    <group rotation={[0, 0, Math.PI / 4]}>
      <Points ref={ref} positions={sphere} stride={3} frustumCulled={false}>
        <PointMaterial
          transparent
          color="#ffa0e0"
          size={0.006}
          sizeAttenuation
          depthWrite={false}
        />
      </Points>
    </group>
  );
}

function Home() {
  const navigate = useNavigate();

  return (
    <>
      <style>{`
        * { box-sizing: border-box; }

        body {
          margin: 0;
          font-family: "Segoe UI", system-ui, sans-serif;
        }

        .home {
          background: #0f2027;
          color: #ffffff;
        }

        .hero {
          position: relative;
          height: 100vh;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .hero-canvas {
          position: absolute !important;
          inset: 0;
          z-index: 0;
        }

//         .hero::after {
//   content: "";
//   position: absolute;
//   inset: 0;
//   background: linear-gradient(
//     135deg,
//     rgba(15,32,39,0.55),
//     rgba(32,58,67,0.55),
//     rgba(44,83,100,0.55)
//   );
//   z-index: 1;
// }
.hero::after {
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 1;
}


        .hero-box {
          position: relative;
          z-index: 2;
          max-width: 750px;
          text-align: center;
          padding: 20px;
        }

        .hero-box h1 {
          font-size: 3.2rem;
          margin-bottom: 12px;
        }

        .hero-box p {
          font-size: 1.15rem;
          line-height: 1.6;
          opacity: 0.9;
        }

        .hero-actions {
          margin-top: 35px;
          display: flex;
          justify-content: center;
          gap: 20px;
        }

        .btn {
          padding: 14px 38px;
          font-size: 1rem;
          font-weight: 600;
          border-radius: 30px;
          cursor: pointer;
          border: none;
          transition: all 0.3s ease;
        }

        .btn-services {
          background: #ffffff;
          color: #0f2027;
        }

        .btn-services:hover {
          transform: translateY(-3px);
          box-shadow: 0 10px 25px rgba(255,255,255,0.3);
        }

        .btn-contact {
          background: transparent;
          color: #ffffff;
          border: 2px solid #ffffff;
        }

        .btn-contact:hover {
          background: rgba(255,255,255,0.15);
          transform: translateY(-3px);
        }

        @media (max-width: 600px) {
          .hero-box h1 {
            font-size: 2.2rem;
          }
          .hero-actions {
            flex-direction: column;
          }
        }
      `}</style>

      <div className="home">
        <section className="hero">
          <Canvas
            className="hero-canvas"
            camera={{ position: [0, 0, 1], fov: 75 }}
          >
            <Stars />
          </Canvas>

          <div className="hero-box">
            <h1>Build Your Future in Technology</h1>
            <p>
              Learn industry-relevant skills with hands-on projects, expert
              mentorship, and real-world exposure.
            </p>

            <div className="hero-actions">
              <button
                className="btn btn-services"
                onClick={() => navigate("/services")}
              >
                Services
              </button>

              <button
                className="btn btn-contact"
                onClick={() => navigate("/contact")}
              >
                Contact Us
              </button>
            </div>
          </div>
        </section>

        <PlacedStudents />
        <Testimonials />
      </div>
    </>
  );
}

export default Home;
